export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const RESTORE_PASSWORD = "RESTORE_PASSWORD"; 